import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@ontruck/orc';
import { i18n } from 'i18n';
import { IS_TENANT, isTenantByName } from 'tenant/utils';

const Footer = ({ className, t }) => {
  const { language } = i18n;
  if (IS_TENANT || isTenantByName('xpo')) return <></>;
  return (
    <div className={className}>
      <div className="wrap">
        <p
          className="left"
          dangerouslySetInnerHTML={{ __html: t('call_us') }}
        />
        <div className="right">
          {language !== 'fr' && (
            <Link
              href="login?lang=fr"
              text={t('fr_label')}
              skin="light"
              size="L"
            />
          )}
          {language.split('-')[0] !== 'es' && (
            <Link
              href="login?lang=es"
              text={t('es_label')}
              skin="light"
              size="L"
            />
          )}
        </div>
      </div>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
  t: PropTypes.func,
};

Footer.defaultProps = {
  className: '',
  t: (t) => t,
};

export default Footer;
